<div class="scad-drag-sidemenu">
<div class="scad-title__semi-bold mb-4">Source</div>
<!-- <div class="scad-title__sm-label">Connect a file or database</div>
<div class="mt-3">
  <span class='clickUpload btn' (click)="file.click()">
    <input type='file' #file (change)="onFileChange($event.target, 'click')">
    <span>{{_flowBuilder.activeNode?.sourceFile?_flowBuilder.activeNode?.sourceFile:'Select a File'}}</span>
  </span>
</div> -->

  <div *ngIf="!clickInput">
    <div class="scad-title__sm-label">You can pick a connector, previous dataset, or upload a new file below.</div>

    <div>
      <div class="d-flex align-items-center pb-3 pt-3">
        <div class="scad-radio">
          <label class="scad-title__sm-thin-gray2"><input type="radio" class="input-radio blue" name="input-type" value="connector" [(ngModel)]="sourceType"> Connector </label>
        </div>
        <div class="scad-radio ps-3">
          <label class="scad-title__sm-thin-gray2"><input type="radio" class="input-radio blue"  name="input-type" value="dataset" [(ngModel)]="sourceType"> Dataset </label>
        </div>
      </div>
    </div>

    <div class="line"></div>


    <div class="pt-4 pb-4">
      <div class="scad-input scad-input--search-right-border">
        <div class="scad-input__search-icon">
          <em class="scad-icon scad-icon-Search"></em>
        </div>
        <input type="text" class="scad-input scad-input--search-right-border" placeholder="Search.."/>
      </div>
    </div>


    <div class="scad-scroll-box excel-data" *ngIf="_flowBuilder.activeNode?.sourceFile && sourceType==='dataset'">
      <!-- searchFilterPipe -->
        <div  class="scad-destination-card  mb-3" (click)="clickInput= true">
          <div class="d-flex justify-content-end align-items-center" >
            <div class="scad-destination-card__logo d-flex"> <img src="../../../../../assets/images/svg/excel-icon.svg" alt="" /> </div>
            <div  class="scad-destination-card__label ps-4">{{_flowBuilder.activeNode?.sourceFile}}</div>
          </div>
          <!-- <div>
            <div class="scad-destination-card__info hover-content-tooltip" (mouseenter)="tooltipDiv=true" (mouseleave)="tooltipDiv=false">
              <img src="assets//images/svg/info.svg" alt="" />
            </div>

          </div> -->
          <div [mtxTooltip]="tooltipTpl" mtxTooltipPosition="below"> <img src="assets//images/svg/info.svg" alt="" />
  </div>

        <ng-template #tooltipTpl>
          <div class="hover-content">
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added by</div>
              <div class="ms-2 hover-content__item-content">Ahmed Khalifa Al-Mansouri </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added on</div>
              <div class="ms-2 hover-content__item-content">04/09/2023, 9:40 am </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added from</div>
              <div class="ms-2 hover-content__item-content">Local System </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item">
              <div class="me-2 hover-content__item-title">Added by</div>
              <div class="ms-2 hover-content__item-content">387 KB </div>
            </div>
          </div>
        </ng-template>
          <!-- <div customToolTip [contentTemplate]="template"><img src="assets//images/svg/info.svg" alt="" /> </div> -->

          <!-- <ng-template #template>
            <div class="hover-content">
              <div class="d-flex justify-content-start hover-content__item mb-2">
                <div class="me-2 hover-content__item-title">Added by</div>
                <div class="ms-2 hover-content__item-content">Ahmed Khalifa Al-Mansouri </div>
              </div>
              <div class="d-flex justify-content-start hover-content__item mb-2">
                <div class="me-2 hover-content__item-title">Added on</div>
                <div class="ms-2 hover-content__item-content">04/09/2023, 9:40 am </div>
              </div>
              <div class="d-flex justify-content-start hover-content__item mb-2">
                <div class="me-2 hover-content__item-title">Added from</div>
                <div class="ms-2 hover-content__item-content">Local System </div>
              </div>
              <div class="d-flex justify-content-start hover-content__item">
                <div class="me-2 hover-content__item-title">Added by</div>
                <div class="ms-2 hover-content__item-content">387 KB </div>
              </div>
            </div>
         </ng-template> -->
<!--
          <div class="hover-content" *ngIf="tooltipDiv">
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added by</div>
              <div class="ms-2 hover-content__item-content">Ahmed Khalifa Al-Mansouri </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added on</div>
              <div class="ms-2 hover-content__item-content">04/09/2023, 9:40 am </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added from</div>
              <div class="ms-2 hover-content__item-content">Local System </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item">
              <div class="me-2 hover-content__item-title">Added by</div>
              <div class="ms-2 hover-content__item-content">387 KB </div>
            </div>
          </div> -->

        </div>



    </div>


    <div class="scad-scroll-box excel-data" *ngIf="sourceType==='connector'">
      <!-- searchFilterPipe -->
        <div  class="scad-destination-card  mb-3" *ngFor="let item of connectorTypes">
          <div class="d-flex justify-content-end align-items-center" >
            <div class="scad-destination-card__logo d-flex"> <img [src]="item.img" alt="" /> </div>
            <div  class="scad-destination-card__label ps-4">{{item.name}}</div>
          </div>
          <div>
            <!-- <div class="scad-destination-card__info hover-content-tooltip" (mouseenter)="tooltipDiv=true" (mouseleave)="tooltipDiv=false">
              <img src="assets//images/svg/info.svg" alt="" />
            </div> -->

            <div [mtxTooltip]="tooltipTpl1" mtxTooltipPosition="below"> <img src="assets//images/svg/info.svg" alt="" /></div>
          </div>

          <ng-template #tooltipTpl1>
          <div class="hover-content">
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added by</div>
              <div class="ms-2 hover-content__item-content">Ahmed Khalifa Al-Mansouri </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added on</div>
              <div class="ms-2 hover-content__item-content">04/09/2023, 9:40 am </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item mb-2">
              <div class="me-2 hover-content__item-title">Added from</div>
              <div class="ms-2 hover-content__item-content">Local System </div>
            </div>
            <div class="d-flex justify-content-start hover-content__item">
              <div class="me-2 hover-content__item-title">Added by</div>
              <div class="ms-2 hover-content__item-content">387 KB </div>
            </div>
          </div>
        </ng-template>
        </div>



    </div>

    <button class="scad-btn scad-btn--secondary download-btn mt-3" (click)="file.click()">
      <input type='file' hidden #file (change)="onFileChange($event.target, 'click')">
      <span>Upload File</span> <span class="ps-2 d-flex">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.6665 8.92578L9.72206 5.875L12.7776 8.92578" stroke="#1847DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.72217 17.3333V6.63744" stroke="#1847DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.3335 2.66669H15.5557" stroke="#1847DF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

      </span>
    </button>

  </div>

  <div *ngIf="clickInput">
      <div class="d-flex align-items-center justify-content-start mb-3" (click)="clickInput= false">
        <span><img src="../../../../../assets/images/svg/arrow-left.svg" alt=""></span>
        <span class="scad-upload__upload-label">Upload File</span>
      </div>

      <div class="scad-upload">
        <div class="scad-upload__wrapper d-flex">
          <div class="scad-upload__left me-3">
            <img src="../../../../../assets/images/svg/excel-icon.svg" alt="">
            <div class="scad-upload__file-type">xlsx</div>
          </div>
          <div class="scad-upload__right">
            <div class="scad-upload__file-label mb-2">{{_flowBuilder.activeNode?.sourceFile}}<span class="scad-upload__close">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 8 8" fill="none">
                <path d="M7.16892 1L1 7.16892" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.16892 7.16892L1 1" stroke="black" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span></div>

            <div class="scad-upload__progress mb-2"></div>

            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="scad-upload__date-time scad-upload__date-time-line">02/08/2023 15:30</div>
                <div class="scad-upload__date-time ms-3">300 ms</div>
              </div>
              <div><img src="../../../../../assets/images/svg/sucess.svg" alt=""></div>
            </div>

          </div>
        </div>
      </div>

      <div class="pb-3 pt-3">
        <div class="scad-title__sm-thin-gray mb-2">Select Worksheet</div>
        <div class="sh-input">
          <ng-select class="shNgclass ng-select-default" [items]="cities" bindLabel="name" placeholder="Select" [(ngModel)]="selectedCity"> </ng-select>
        </div>
      </div>
      <div class="pb-3">
        <div class="scad-title__sm-thin-gray mb-2">Header</div>
        <div class="sh-input">
          <ng-select class="shNgclass ng-select-default"  [items]="cities" bindLabel="name" placeholder="Select" [(ngModel)]="selectedCity"> </ng-select>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-between">
        <div class="scad-upload__date-time">12000 rows, 12 columns</div>
        <div class="scad-upload__upload-label">Preview</div>
      </div>

      <button class="scad-btn scad-btn--secondary download-btn mt-5" >

        <span>Save </span> <span class="ps-2 d-flex">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="11" viewBox="0 0 15 11" fill="none">
            <path d="M9.04157 0.833313L13.7105 5.48846L8.98633 10.2265" stroke="#1847DF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M1.5 5.52991H13.7111" stroke="#1847DF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

        </span>
      </button>



  </div>

</div>
